<template>
  <div class="self-header">
    <!-- <span class="show-phone-inline-block icon" @click="pickerShow = true">
      <van-icon name="wap-nav" />
    </span> -->
    <div class="header-left">
      <!-- 折叠按钮 -->
      <div class="title" v-show="$route.name == 'Home'">{{ title }}</div>
    </div>
    <div class="header-right">
      <el-popover placement="bottom" width="200" trigger="click">
        <p class="text-primary" style="margin-bottom: 2vh">
          {{ userInfo.endBillingPeriod && userInfo.endBillingPeriod.substring(0, 10) }} 到期
        </p>
        <div class="nav">
          <el-button
            size="mini"
            type="warning"
            @click=";(dialogVisable = true), (form = { old: '', new: '', new1: '' })"
            >修改密码
          </el-button>
          <el-button size="mini" type="danger" class="btn" @click="loginOut">退出登录</el-button>
        </div>
        <div class="info-box" slot="reference">
          <span class="avatar">
            <img :src="userInfo.headimgurl || userImg" />
          </span>
          <span
            >{{ userInfo.companyName }} - {{ userInfo.name }}
            <i class="el-icon-caret-bottom"></i>
          </span>
        </div>
      </el-popover>
    </div>
    <van-popup v-model="pickerShow" position="left" :style="{ width: '50%', height: '100%' }">
      <Navbar></Navbar>
    </van-popup>
    <el-dialog :visible.sync="dialogVisable" :append-to-body="true" width="280px">
      <el-row class="seachMsg seachMsg1" :gutter="10">
        <el-col :span="24">
          <span class="width inline">旧密码</span>
          <el-input type="password" v-model="form.old" class="ShortWidth"></el-input>
        </el-col>
      </el-row>
      <el-row class="seachMsg seachMsg1" :gutter="10">
        <el-col :span="24">
          <span class="width inline">新密码</span>
          <el-input type="password" v-model="form.new" class="ShortWidth"></el-input>
        </el-col>
      </el-row>
      <el-row class="seachMsg seachMsg1" :gutter="10">
        <el-col :span="24">
          <span class="width inline">确认密码</span>
          <el-input type="password" v-model="form.new1" class="ShortWidth"></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="text-center dialog-footer">
        <el-button type="primary" @click="updatePwd">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Navbar from './Navbar'
import bus from '../store/bus'
export default {
  name: 'self-header',
  props: {
    title: {
      type: String,
      default: '标题'
    }
  },
  components: {
    Navbar
  },
  data() {
    return {
      navIsCollapse: this.$store.state.navIsCollapse,
      userInfo: {
        company: '代账公司',
        userImg: require('@/assets/img/user.png')
      },
      userImg: require('@/assets/img/user.png'),
      noticeLogo: require('@/assets/img/icon-notice.png'),
      pickerShow: false,
      dialogVisable: false,
      form: {
        old: '',
        new: '',
        new1: ''
      },
      collapse: true
    }
  },
  methods: {
    // 侧边栏折叠
    collapseChage() {
      console.log(this.collapse)
      this.collapse = !this.collapse
      bus.$emit('collapse', this.collapse)
    },
    loginOut() {
      this.$root.$children[0].vueConfirm(
        { message: '确定退出登录吗？', title: '提示', type: 'warning' },
        () => {
          this.$common.session.clear()
          this.$router.push('/')
        },
        () => {}
      )
    },
    updatePwd() {
      if (!this.form.old) {
        return this.$root.$children[0].vueAlert({ message: '请输入旧密码！', type: 'warning' })
      }
      if (!this.form.new) {
        return this.$root.$children[0].vueAlert({ message: '请输入新密码！', type: 'warning' })
      }
      if (this.form.new !== this.form.new1) {
        return this.$root.$children[0].vueAlert({ message: '请再次确认新密码！', type: 'warning' })
      }
      this.$confirm('确定要修改密码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            id: this.userInfo.cid,
            oldPwd: this.form.old,
            newPwd: this.form.new
          }
          this.$get('/user/updatePwd', param).then(
            result => {
              if (result.status === 200) {
                this.dialogVisable = false
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' }, () => {
                  this.$common.session.clear()
                  this.$router.push('/')
                })
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消修改' })
        })
    }
  },
  watch: {},
  mounted() {
    if (document.body.clientWidth < 1500) {
      this.collapseChage()
    }
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    } else {
      return this.$root.$children[0].vueAlert({ message: '未获取到用户信息', type: 'warning' })
    }
  }
}
</script>
<style lang="less">
.el-popover {
  .nav {
    display: flex;
    justify-content: space-between;
  }
}
</style>
<style lang="less" scoped>
.self-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #242f42;
  padding: 0 20px;
  height: 100%;
}
.icon {
  font-size: 3vh;
  color: #fff;
  line-height: 5vh;
}
.header-left {
  display: flex;
  align-items: center;
  .menu {
    width: 64px;
    .tu {
      padding: 5px 0;
      width: 25px;
      height: 3px;
      margin-left: 0.5vw;
      background: #d8d8d8;
      background-clip: content-box; //背景颜色从内容区域开始绘制
      border-top: 3px solid #d8d8d8;
      border-bottom: 3px solid #d8d8d8;
    }
  }
  .title {
    flex: 1;
    font-size: 20px;
    color: #aaa;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.header-right {
  display: flex;
  .avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    margin-right: 1vw;
    img {
      border-radius: 50%;
      height: 4.2vh;
    }
  }
  .info-box {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
    height: 100%;
    color: #fff;
    text-align: right;
    font-weight: bold;
    cursor: pointer;
  }
  .notice {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 8vw;
    border-left: 0.08vw solid #666;
    .img {
      position: relative;
      width: 1.52vw;
      height: 1.62vw;
      img {
        width: 1.52vw;
        height: auto;
      }
      .point {
        position: absolute;
        top: 0;
        right: -0.21vw;
        width: 0.42vw;
        height: 0.42vw;
        border-radius: 50%;
        background: #f0795a;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .icon {
    font-size: 3vh;
    color: #fff;
    line-height: 5vh;
  }
  .header-right {
    display: flex;
    .avatar {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      cursor: pointer;
      img {
        border-radius: 50%;
        height: 3.1vh;
      }
    }
    .info {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;
      overflow: hidden;
      padding: 1vh;
      text-align: right;
      font-weight: bold;
      .company {
        position: relative;
        left: -3vw;
        padding: 0 1vw 0 2vw;
        min-width: 5vw;
        height: 2.3vw;
        border-radius: 0.42vw;
        border: 0.08vw solid #666;
        font-size: 1vw;
        line-height: 2.3vw;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
      .clock {
        font-size: 2vh;
        line-height: 2vh;
      }
    }
  }
}
</style>
